<template>
    <div class="searchBox__content">
        <div class="searchListTop">
            <div
                ref="searchList"
                v-hammer:pan.horizontal="handlePanHorizontal"
                class="searchListTop__wrap"
            >
                <div
                    v-for="section in filterSections"
                    class="searchListTop__item"
                    :class="{
                        ['searchListTop__item--active']:
                            sectionContactsSelected.key === section.key,
                    }"
                    @click="handleSectionClick(section)"
                >
                    <div class="searchListTop__title">
                        {{ section.label }}
                    </div>
                    <div class="searchListTop__total">{{ totalSection(section.key) }}</div>
                </div>
            </div>
        </div>
        <search-items
            v-if="sectionContactsSelected.key === 'salesmsg'"
            :name="'contactsSearch'"
            :items="contactsSearch"
            :pagination="contactsSearchPagination"
            :counter="counter"
            :starting="starting"
            :limit="searchLimit"
            :query="query"
            :newSearch="newSearch"
            :shouldShowStart="shouldShowStart"
            @enter="enter"
            @start="start"
            @mouse-over="mouseOver"
            @mouse-out="mouseOut"
        />

        <search-items
            v-if="sectionContactsSelected.key === 'pipedrive'"
            :name="'contactsPipedriveSearch'"
            :items="contactsPipedriveSearch"
            :pagination="contactsPipedriveSearchPagination"
            :counter="counter"
            :starting="starting"
            :limit="searchLimit"
            :query="query"
            :newSearch="newSearch"
            :shouldShowStart="shouldShowStart"
            @enter="enter"
            @start="start"
            @mouse-over="mouseOver"
            @mouse-out="mouseOut"
        />

        <search-items
            v-if="sectionContactsSelected.key === 'infusionsoft'"
            :name="'contactsInfusionsoftSearch'"
            :items="contactsInfusionsoftSearch"
            :pagination="contactsInfusionsoftSearchPagination"
            :counter="counter"
            :starting="starting"
            :limit="searchLimit"
            :query="query"
            :newSearch="newSearch"
            :shouldShowStart="shouldShowStart"
            @enter="enter"
            @start="start"
            @mouse-over="mouseOver"
            @mouse-out="mouseOut"
        />

        <search-items
            v-if="sectionContactsSelected.key === 'hubspot'"
            :name="'contactsHubSpotSearch'"
            :items="contactsHubSpotSearch"
            :pagination="contactsHubSpotSearchPagination"
            :counter="counter"
            :starting="starting"
            :limit="searchLimit"
            :query="query"
            :newSearch="newSearch"
            :shouldShowStart="shouldShowStart"
            @enter="enter"
            @start="start"
            @mouse-over="mouseOver"
            @mouse-out="mouseOut"
        />

        <search-items
            v-if="sectionContactsSelected.key === 'activecampaign'"
            :name="'contactsActiveCampaignSearch'"
            :items="contactsActiveCampaignSearch"
            :pagination="contactsActiveCampaignSearchPagination"
            :counter="counter"
            :starting="starting"
            :limit="searchLimit"
            :query="query"
            :newSearch="newSearch"
            :shouldShowStart="shouldShowStart"
            @enter="enter"
            @start="start"
            @mouse-over="mouseOver"
            @mouse-out="mouseOut"
        />

        <search-items
            v-if="sectionContactsSelected.key === 'salesforce'"
            :name="'contactsSalesforceSearch'"
            :items="contactsSalesforceSearch"
            :pagination="contactsSalesforceSearchPagination"
            :counter="counter"
            :starting="starting"
            :limit="searchLimit"
            :query="query"
            :newSearch="newSearch"
            :shouldShowStart="shouldShowStart"
            @enter="enter"
            @start="start"
            @mouse-over="mouseOver"
            @mouse-out="mouseOut"
        />
    </div>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import SearchItems from './SearchItems';

export default {
    components: {
        SearchItems,
    },

    props: {
        filterSections: { type: Array, required: true },
        counter: { type: Number, required: true },
        starting: { type: Boolean, required: true },
        totalSection: { type: Function, required: true },
        contactsPipedriveSearch: { type: Array, required: true },
        contactsPipedriveSearchPagination: { type: Object, required: true },
        contactsInfusionsoftSearch: { type: Array, required: true },
        contactsInfusionsoftSearchPagination: { type: Object, required: true },
        contactsHubSpotSearch: { type: Array, required: true },
        contactsHubSpotSearchPagination: { type: Object, required: true },
        contactsActiveCampaignSearch: { type: Array, required: true },
        contactsActiveCampaignSearchPagination: { type: Object, required: true },
        contactsSalesforceSearch: { type: Array, required: true },
        contactsSalesforceSearchPagination: { type: Object, required: true },
        contactsSearch: { type: Array, required: true },
        contactsSearchPagination: { type: Object, required: true },
        searchLimit: { type: Number, required: true },
        query: { type: String, default: '' },
        newSearch: { type: Boolean, default: false },
        shouldShowStart: { type: Boolean, default: true },
    },

    computed: {
        ...mapState(stores.Search, ['sectionContactsSelected']),
    },

    methods: {
        handleSectionClick(section) {
            this.$emit('handleSectionClick', section);
        },

        start(contact) {
            this.$emit('start', contact);
        },

        enter(contact, type, label) {
            this.$emit('enter', contact, type, label);
        },

        mouseOver(i) {
            this.$emit('mouseOver', i);
        },

        mouseOut() {
            this.$emit('mouseOut');
        },

        handlePanHorizontal(e) {
            if (this.$refs.searchList) {
                const speed = 20;

                if (e.additionalEvent === 'panleft' || e.additionalEvent === 'panright') {
                    this.$refs.searchList.scrollLeft =
                        this.$refs.searchList.scrollLeft - speed * e.velocityX;
                }
            }
        },
    },
};
</script>
